import styled from 'styled-components'

export const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};

  :first-child {
    // to show icon when the item is selected (ComboBox hides the icon by default for the selected item)
    display: block;
  }
`
